export enum REPORTS_TABS {
  HOME = 'HOME',
  GOOGLE = 'GOOGLE MAPS',
  APPLE = 'APPLE MAPS',
  BING = 'BING',
  YELP = 'YELP',
  REPORTS_TOOLS = 'REPORTS TOOL',
  LOG = 'REPORT LOG',
  ACCURACY = 'ACCURACY',
}
